import type { CanonicalAddress } from "@tycho/web-bindings/types";

export function formatCanonicalAddressFull(address: CanonicalAddress) {
  return `${address.addressLine1}${address.addressLine2 ? ` ${address.addressLine2}` : ""} ${address.city}, ${address.state} ${address.zip}`;
}

export function formatCanonicalAddressMedium(address: CanonicalAddress) {
  return `${address.addressLine1} ${address.city}, ${address.state}`;
}

export function formatCanonicalAddressShort(address: CanonicalAddress) {
  return address.addressLine1;
}
